import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import { DetailDataChanges } from "../partial/OrderRequestDetailDialog.partial";

/** check the error of catering quantity changes */
export const checkCateringDetailError = (
  props: DetailDataChanges,
  editedData: DetailedServiceBookingData | null,
  isResourceCateringOrder = false
) => {
  const { id, newQty } = props;

  if (isResourceCateringOrder) {
    if (!newQty || newQty <= 0) {
      return "min";
    }
    return null;
  }

  // Validate quantity only for conference catering delivery qty
  const selected = editedData?.caterings.find(cat => cat.id === id);
  const maxQty = selected?.orderedQty || selected?.quantity || 5;
  const nullAvailableQty = selected?.availableQty === null;

  if (!newQty || newQty <= 0) {
    return "min";
  } else if (newQty > maxQty) {
    return "max";
  } else if (nullAvailableQty) {
    return "empty";
  }
  return null;
};
